import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceSad12Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFaceSad12Filled"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#FaceSad12Filled)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12M3.75 5.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M3.319 9.366a.5.5 0 0 0 .645-.28l.001-.003.012-.026q.019-.04.066-.118c.064-.103.167-.245.32-.388.296-.278.802-.58 1.637-.58s1.34.302 1.638.58a1.9 1.9 0 0 1 .385.506l.012.026v.002a.5.5 0 0 0 .931-.366L8.5 8.9l.466-.182v-.002l-.002-.003-.003-.007-.01-.021-.029-.065a2.9 2.9 0 0 0-.601-.8C7.854 7.385 7.109 6.972 6 6.972s-1.854.413-2.32.85a2.9 2.9 0 0 0-.602.799l-.03.065-.009.02-.003.008-.001.003v.002L3.5 8.9l-.466-.181a.5.5 0 0 0 .285.647m4.716-.283"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="FaceSad12Filled">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconFaceSad12Filled);
